export default function cleanUri() {
  const { protocol, host, pathname } = window.location;
  const uri = `${protocol}//${host}${pathname}`;
  window.history.replaceState({}, document.title, uri);
}
